import type { RouteObject } from 'react-router-dom';
import { SettingsAnalyticsPage } from '~/pages/settings/analytics';
import { Action, Resource } from '~/api/graphql';
import { ProtectedRoute } from '~/components/permissions';

export const analyticsRoute: RouteObject = {
  path: 'analytics',
  element: (
    <ProtectedRoute
      permissions={[{ resource: Resource.Analytics, action: Action.Read }]}
      redirectTo="/app/settings/profile"
    >
      <SettingsAnalyticsPage />
    </ProtectedRoute>
  )
};
